var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "player",
      class: { disabled: _vm.disabled },
      on: {
        click: function ($event) {
          return _vm.play()
        },
      },
    },
    [
      _c("div", { staticClass: "action" }, [
        _c("span", {
          staticClass: "icon-play",
          class: { playing: _vm.playing },
        }),
        _vm.duration
          ? _c("span", [
              _vm._v(" " + _vm._s(_vm.duration) + " "),
              _c("span", { staticClass: "seconds" }, [_vm._v('"')]),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "status" }, [
        _vm.error
          ? _c("i", { staticClass: "el-icon-warning-outline error" })
          : _vm._e(),
        _vm.loading
          ? _c("i", { staticClass: "el-icon-loading loading" })
          : _vm._e(),
      ]),
      _c("audio", {
        ref: "audio",
        attrs: { src: _vm.src },
        on: {
          loadedmetadata: _vm.loadedMetaData,
          pause: _vm.onPause,
          play: _vm.onPlay,
          timeupdate: _vm.onTimeUpdate,
          error: _vm.onError,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }